/* Presentation only: reserve the measured mobile toolbar height for Shopify Forms. */
(() => {
  const closeLabel = document.currentScript?.dataset.closeLabel;
  const mobile = matchMedia('(max-width: 1024px)');
  const root = document.documentElement;
  let frame = 0;
  let toolbar;
  const installed = new WeakSet();
  const floatingCSS = `
    /* Keep the floating signup compact. The inline footer form has its own styles. */
    [data-form-root][data-layout="floating"] [data-sizing="form-wrapper"] {
      height: auto !important;
      min-height: 0 !important;
      grid-template-columns: minmax(0, 1fr) !important;
      grid-template-rows: auto !important;
      align-content: start;
    }
    [data-form-root][data-layout="floating"] [data-sizing="form-wrapper"] :is(img, picture),
    [data-form-root][data-layout="floating"] [data-sizing="form-wrapper"] :is(div, figure):has(> :is(img, picture)):not(:has(button, a, form, input)) {
      display: none !important;
    }
    [data-form-root][data-layout="floating"] [data-sizing="form-wrapper"] :is([class*="_image"], [class*="_Image"]):not(img, picture):not(:has(button, a, form, input)) {
      display: none !important;
    }
    @media (max-width: 767px) {
      [data-form-root][data-layout="floating"] section[data-sizing="form-wrapper"] {
        padding: 28px 20px 20px !important;
      }
      [data-form-root][data-layout="floating"] [data-sizing="form-wrapper"] [class*="_formHeader"] {
        gap: 8px !important;
      }
    }

    /* The app positions its dialog independently of the floating launcher.
       Leave that launcher unclipped and scroll only the dialog panel. */
    @media (max-width: 1024px) {
      [data-form-root][data-layout="floating"][data-position^="bottom-"]:not(:has([data-sizing="form-wrapper"])) {
        bottom: calc(var(--nekoan-mobile-nav-height, 60px) + 12px) !important;
      }
      [data-form-root][data-layout="floating"]:has([data-sizing="form-wrapper"]) {
        overflow: visible !important;
        max-height: none !important;
      }
      [data-form-root][data-layout="floating"] section:has(> [data-sizing="form-wrapper"]),
      [data-form-root][data-layout="floating"] section[data-nekoan-dialog-shell] {
        position: fixed !important;
        inset: env(safe-area-inset-top, 0px) 0 calc(var(--nekoan-mobile-nav-height, 60px) + env(safe-area-inset-bottom, 0px)) !important;
        width: auto !important;
        height: auto !important;
        align-items: center;
        justify-content: center;
        padding: 12px;
        box-sizing: border-box;
        overflow: visible !important;
        transform: none !important;
      }
      [data-form-root][data-layout="floating"] [data-sizing="form-wrapper"] {
        box-sizing: border-box;
        min-width: 0 !important;
        max-width: 100% !important;
        max-height: calc(100vh - var(--nekoan-mobile-nav-height, 60px) - 24px);
        max-height: calc(100dvh - var(--nekoan-mobile-nav-height, 60px) - 24px - env(safe-area-inset-top, 0px) - env(safe-area-inset-bottom, 0px));
        overflow-y: auto !important;
        overscroll-behavior: contain;
      }
      input:not([type="checkbox"]):not([type="radio"]), select, textarea { font-size: 16px !important; }
    }`;
  const inlineCSS = `
    @media (max-width: 1024px) {
      input:not([type="checkbox"]):not([type="radio"]), select, textarea { font-size: 16px !important; }
    }`;
  // The submenu heading also serves as the parent category link.
  document.addEventListener('click', event => {
    if (event.target.closest?.('[data-nekoan-menu-destination]')) event.stopPropagation();
  }, true);

  const measure = () => {
    frame = 0;
    const next = document.querySelector('.halo-sticky-toolbar-mobile');
    if (next && next !== toolbar) {
      if (toolbar) resize.unobserve(toolbar);
      toolbar = next;
      resize.observe(toolbar);
    }
    const height = mobile.matches && toolbar && getComputedStyle(toolbar).display !== 'none'
      ? Math.ceil(toolbar.getBoundingClientRect().height) : 0;
    root.style.setProperty('--nekoan-mobile-nav-height', height + 'px');
    document.querySelectorAll('[id^="ProductSection-"]').forEach(section => {
      const title = section.querySelector('h1');
      if (!title) return;
      if (!title.id) title.id = section.id + '-media-label';
      section.querySelectorAll('.productView-nav .slick-track, .productView-for .slick-track').forEach(track => {
        if (track.getAttribute('aria-labelledby') !== title.id) track.setAttribute('aria-labelledby', title.id);
      });
    });
    document.querySelectorAll('shopify-forms-embed').forEach(host => {
      if (!host.shadowRoot || installed.has(host)) return;
      const style = document.createElement('style');
      style.dataset.nekoanMobileUI = '';
      style.textContent = host.id.startsWith('app-embed-container-') ? floatingCSS : inlineCSS;
      host.shadowRoot.append(style);
      const normalizeDialogs = () => {
        if (closeLabel) host.shadowRoot.querySelectorAll('button[aria-label="Close modal"]').forEach(button => button.setAttribute('aria-label', closeLabel));
        host.shadowRoot.querySelectorAll('section[role="dialog"]:not([data-sizing])').forEach(wrapper => {
          const dialog = wrapper.querySelector('[role="dialog"][data-sizing="form-wrapper"]');
          if (!dialog || !(dialog.getAttribute('aria-label') || dialog.getAttribute('aria-labelledby'))) return;
          wrapper.dataset.nekoanDialogShell = '';
          wrapper.removeAttribute('role');
          wrapper.removeAttribute('aria-modal');
        });
      };
      new MutationObserver(normalizeDialogs).observe(host.shadowRoot, {childList: true, subtree: true});
      normalizeDialogs();
      installed.add(host);
    });
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(measure); };
  const resize = new ResizeObserver(schedule);
  new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node =>
      node.nodeType === 1 && (node.matches('shopify-forms-embed,.halo-sticky-toolbar-mobile,.productView-nav,.productView-for') ||
        node.closest('.productView-nav,.productView-for') ||
        node.querySelector('shopify-forms-embed,.halo-sticky-toolbar-mobile,.productView-nav,.productView-for'))))) schedule();
  }).observe(document.body, {childList: true, subtree: true});
  mobile.addEventListener('change', schedule);
  window.addEventListener('resize', schedule, {passive: true});
  window.visualViewport?.addEventListener('resize', schedule, {passive: true});
  document.addEventListener('shopify:section:load', schedule);
  customElements.whenDefined('shopify-forms-embed').then(schedule);
  measure();
})();
